import { lazy } from 'react';
// ----------------------------------------------------------------------

const SelfServicesPage = lazy(() => import('../pages/SelfServices.page'));
const InsurancesPage = lazy(() => import('../pages/Insurances.page'));
const LoansRequestsPage = lazy(() => import('../pages/LoansRequests.page'));
const AttendacesRequestsPage = lazy(() => import('../pages/AttendacesRequests.page'));
const ServicesPage = lazy(() => import('../pages/Services.page'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));

// ----------------------------------------------------------------------

const SelfServicesRoutes = [
    {
        path: '/self-services',
        children: [
            {
                element: <SelfServicesPage />,
                layout: 'default',
                isAuthReq: true,
                index: true,
                
            },
            {
                path: 'insurances',
                element: <InsurancesPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'holidays-requests',
                element: <AttendacesRequestsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'loans',
                element: <LoansRequestsPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'services',
                element: <ServicesPage />,
                layout: 'default',
                isAuthReq: true,
            },

            {
                path: 'services/complaints/add',
                element: <AddComplaintPage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
];

export { SelfServicesRoutes };
